import { render, staticRenderFns } from "./reporta2.vue?vue&type=template&id=07eda6ae&"
import script from "./reporta2.vue?vue&type=script&lang=js&"
export * from "./reporta2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports